import React, { useRef, useState } from 'react'
import styles from './styles.module.scss'

interface Props {
    length?: number
    onChange: (value: string) => void
    value?: string
}

export default function OtpInput({ length = 6, onChange, value = '' }: Props) {
    const [otp, setOtp] = useState(value.split(''))
    const inputRefs = useRef<(HTMLInputElement | null)[]>([])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const value = e.target.value
        if (isNaN(Number(value))) return

        const newOtp = [...otp]
        newOtp[index] = value.substring(value.length - 1)
        setOtp(newOtp)

        const combinedValue = newOtp.join('')
        onChange(combinedValue)

        if (value && index < length - 1) {
            inputRefs.current[index + 1]?.focus()
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus()
        }
    }

    const handlePaste = (e: React.ClipboardEvent) => {
        e.preventDefault()
        const pastedData = e.clipboardData.getData('text/plain')
        const pastedNumber = pastedData.substring(0, length)

        if (!/^\d+$/.test(pastedNumber)) return

        const newOtp = pastedNumber.split('')
        setOtp(newOtp)
        onChange(pastedNumber)

        inputRefs.current[pastedNumber.length - 1]?.focus()
    }

    return (
        <div className={styles.container}>
            {[...Array(length)].map((_, index) => (
                <input
                    key={index}
                    ref={el => { inputRefs.current[index] = el }}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={otp[index] || ''}
                    onChange={e => handleChange(e, index)}
                    onKeyDown={e => handleKeyDown(e, index)}
                    onPaste={handlePaste}
                    className={styles.input}
                    autoFocus={index === 0}
                />
            ))}
        </div>
    )
}